import { BaseTag } from 'mixs/base/base_mixin';
import moment from 'moment';
import { api } from 'apps/api';
import ReadController from 'mixs/notifications/read-controller';
import jump from 'jump.js';
import {
  COMMENT_CLICK_REMOVE,
  COMMENT_CLICK_REPLY,
  GOTO_THE_COMMENT
} from 'apps/events';
import TimeLag from 'utilities/timelag';
import { Scopes } from 'apps/scopes';
import RiotEventManager   from 'utilities/riot/event_manager';

class Global extends Scopes {
}

class CommentsComment extends BaseTag {
  blurCallback;
  eventManager: RiotEventManager;
  showReply: boolean = false;
  isFocus: boolean = false;
  checkTimeLag: TimeLag;
  init(){
    super.init();
    this.eventManager = new RiotEventManager(this)
    this.eventManager.customEvent(GOTO_THE_COMMENT, (e) => {this.gotoTheComment(e)})
    this.watchData('data.forms_comments_reply.inputs.parent_id.value', (a, b,c) => { this.onChangeCommentReply(a, b, c)});
    this.listenMount([this.onMountComment])
  }
  onChangeCommentReply(parent_id, oldVal, objectPath){
    if(parent_id == this.opts.id){this.showReply = true;}
    else{this.showReply = false;}
    this.update();
  }
  onClickWrap(){
    if(this.isFocus){ return false; }
    this.blurCallback = (e) => { this.blur(); }
    document.addEventListener('mouseup', this.blurCallback);
    this.focus();
  }
  focus(){
    this.isFocus = true;
    this.update();
    this.onClickReply();
  }
  blur(){
    document.removeEventListener('mouseup', this.blurCallback);
    setTimeout(() => {
      this.isFocus = false;
      this.update();
    }, 1)
  }
  gotoTheComment(e){
    if(!e.detail.target_id){ return; }
    if(this.opts.id != e.detail.target_id){ return; }
    setTimeout(() => {
      jump(this.rootElement(),{
        duration: 500,
        offset: -80
      })
    }, 500)
    setTimeout(() => {
      let el = this.rootElement();
      let className = 'glow'
      if (el.classList)
        el.classList.add(className);
      else
        el.className += ' ' + className;
    }, 1500)
    this.focus();
  }
  onClickReply(){
    let customEvent = new CustomEvent(COMMENT_CLICK_REPLY, {detail: this.opts.id})
    document.dispatchEvent(customEvent);
  }
  onClickRemove(){
    let customEvent = new CustomEvent(COMMENT_CLICK_REMOVE, {detail: this.opts.id})
    document.dispatchEvent(customEvent);
  }
  taskData(){
    if(this.opts.task_id == null){ return null }
    if(this.opts.task_id == ''){ return null }
    return Global.getTaskData(this.opts.task_id);
  }
  phaseData(){
    let taskData = this.taskData();
    if(taskData == null){ return null }
    return Global.getPhaseData(taskData.phase_id)
  }
  colorcode(){
    let phaseData = this.phaseData();
    if(phaseData == null){ return '' }
    return phaseData.colorcode;
  }

  phaseName(){
    let phaseData = this.phaseData();
    if(phaseData == null){ return '' }
    return phaseData.name;
  }
  userName(){
    let userData = Global.getUserData(this.opts.user_id);
    if(userData == null){ return '**' }
    return userData.name;
  }
  at(){
    let created_at_moment = moment(this.opts.created_at);
    return created_at_moment.format('YYYY/MM/DD hh:mm');
  }
  onMountComment(){
    this.check();
  }
  check(){
    this.checkTimeLag = new TimeLag(() => {this.checkDo()}, 1000);
    this.checkTimeLag.start();
  }
  checkDo(){
    if(this.isInViewport()){
      this.onRead();
    }else{
      this.check();
    }
  }
  isInViewport() {
    let elem = this.rootElement();
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  onRead(){
    let commentsNotificationsData = Global.getCommentsNotificationsData(this.opts.id);
    if(commentsNotificationsData == null){ return; }
    let items = commentsNotificationsData.items;
    let unread_notifications = []
    for(let i=0;i<items.length;i++){
      let notificationData = Global.getNotificationData(items[i]);
      if(notificationData == null){ continue; }
      if(!notificationData.unread){ continue; }
      if(notificationData.user_id != Global.getCurrentUserData().id){ continue; }
      unread_notifications.push(notificationData.id);
    }
    if(unread_notifications.length > 0){
      let c = ReadController.getInstance();
      c.onRead(unread_notifications)
    }
  }
}

riot.mixin('comments.comment', CommentsComment as riot.TagMixin)
